var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"v-button",class:{
    hover: _vm.hover,
    loading: _vm.loading,
    disabled: _vm.disabled,
    outlined: _vm.outlined
  },attrs:{"type":_vm.type},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[(_vm.showBackgroundAnimation)?_c('div',{staticClass:"background-animation"},[_c('div',{staticClass:"line"})]):_vm._e(),_vm._v(" "),_vm._t("loading",function(){return [(_vm.animated && _vm.loading)?_c('IconLoading'):_vm._e()]}),_vm._v(" "),_c('span',[_vm._t("default")],2),_vm._v(" "),_vm._t("custom-label")],2)}
var staticRenderFns = []

export { render, staticRenderFns }